import { CSSObjectWithLabel, Theme } from "react-select";

export const selectStyles = (theme: Theme) => {
  return {
    ...theme,
    borderRadius: 0,
    colors: {
      ...theme.colors,
      primary: "#dee2e6",
      primary25: "#2cd0af",
      neutral20: "#ebebeb",
    },
  };
};

// The Device Modal's selects follow its Figma: 36px tall with a 1px radius.
// The indicators set the control's height, so their padding shrinks too.
export const compactSelectStyles = (theme: Theme) => ({
  ...selectStyles(theme),
  borderRadius: 1,
  spacing: { ...theme.spacing, controlHeight: 36 },
});

const compactIndicator = (base: CSSObjectWithLabel) => ({
  ...base,
  paddingTop: 7,
  paddingBottom: 7,
});

export const compactSelectIndicators = {
  dropdownIndicator: compactIndicator,
  clearIndicator: compactIndicator,
};
